export const UpdateCommonInfo = 'UpdateCommonInfo';